import { render, staticRenderFns } from "./DesiredLoan.vue?vue&type=template&id=71f1802a"
import script from "./DesiredLoan.vue?vue&type=script&lang=js"
export * from "./DesiredLoan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports